import React, { Component } from "react";
import ChatList from "./ChatList";
import ChatBox from "./chatBox";
import * as HTTPServices from "../../api/HTTPServices";
import _ from "lodash";
import FileUpload from "./FileUploadDialog";
// import VoiceRecorder from "./VoiceRecorderDialog";
// import VoiceRecorder from "./NewVoiceRecorder/NewVoiceRecorder";
import VoiceRecorder from "./NewVoiceRecorder";


import VideoRecorderDialoge from "./VideoRecordDialoge";
// import VideoRecorderDialoge from "./NewVideoRecorder/NewVideoRecorder";
import { Box } from "@mui/material"
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
// import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import AddAttachFile from "../../components/user/customer/Meeting/room/AttachFile/AddAttachFile";
import AddPrescription from "../user/doctor/Meeting/room/Prescription/AddPrescription";
import CompressedImageUpload from "../../components/ChatCall/CompressedImageUploadDialoge";

import DriveFolderUploadRoundedIcon from '@mui/icons-material/DriveFolderUploadRounded';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import "react-h5-audio-player/lib/styles.css";
import * as DataServices from '../../api/DataServices';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import NotificationBar from './n';
import { io } from 'socket.io-client';
import appConfig from "../../config/appConfig";
import { Percent } from "@mui/icons-material";


// import { webSocketSbm } from "../../hooks";

const WAIT_INTERVAL = 2000;

class ChatCall extends Component {

  constructor(props) {

    super(props);
    const { UserLogin } = this.props;


    this.user = {
      id: UserLogin.client_id,
      name: UserLogin.fullname,
    };

    this.state = {
      tarikh: this.props.date,
      rep_to: null,
      deleted_id: null,
      firstload: true,
      loading: true,
      text: "",
      username: this.user.name,
      chats: [],
      showFileUploadMenu: false,
      showVoiceRecordMenu: false,
      confirmDeleteDialoge: false,
      selectedChat: {},
      showVideoRecordMenu: false,
      showReplyDiv: false,
      selectedToReply: "",
      isTyping: false,
      showRtcUnsupported: false,
      doTyping: false,
      words: ["سلام", "وقت بخیر", "چند لحظه لطفا"],
      showMedicalDocuments: false,
      showMedicalInstructions: false,
      showCompressedUploadMenu: false,
      attachType: "",
      totalSeconds: "",
      audienceUser: "",
      secondsLabel: "00",
      minutesLabel: "00",
    };

    this.handleTextChange = this.handleTextChange.bind(this);
    this.send = this.send.bind(this);
    this.ConfirmDeleteMessage = this.ConfirmDeleteMessage.bind(this);
    this.getVisitDuration = this.getVisitDuration.bind(this);

  }


  //   componentDidMount() {
  //     this.socket = io('https://45.139.10.247');

  //     const en_date = new Date(this.state.tarikh);
  //     const year = en_date.getFullYear();

  //     var live = this;
  //     live.echoJoin();
  //     live.getVisitDuration();

  //     this.socket.emit("fetchMessages", {roomToken: this.props.VisitToken, senderid: this.user.id, geterid: this.props.AudienceID});

  //     this.socket.on(`newMessage:${this.props.VisitToken}`, (newMessage) => {
  //       console.log("new message uptime", newMessage);

  //       //inja




  //       this.setState(prevState => {
  //         const neePrevsChats = (prevState.chats).map((val) => {
  //           return {
  //             ...val, seen_audience: val.audience_id == this.props.AudienceID  && 1 }
  //         })
  //         return{

  //           chats: [...neePrevsChats, newMessage],
  //           showReplyDiv: false,
  //       }}, () => {



  //       });
  //     });

  //     this.socket.on("chatHistory", (messages) => {
  //       this.setState({ chats: messages, loading: false }, () => {
  //           // اسکرول به پایین پس از به‌روزرسانی state
  //           if (document.getElementById("chat_list_end")) {
  //               document.getElementById("chat_list_end").scrollIntoView({ behavior: "smooth" });
  //           }
  //       });
  //     });

  //     window.addEventListener("resize", live.onWindowResize, false);

  //     var mainElement = document.getElementById("main_footer");
  //     mainElement.classList.add("hide_footer");

  //     var footerElement = document.getElementById("main");
  //     footerElement.classList.add("hide_mood_main");
  // }



  componentDidMount() {
    // تنظیمات socket.io
    // توجه: push.sbm24.com بدون SSL است و روی Arvan بدون SSL ست شده
    const socketUrl = appConfig.websocket.socketUrl;
    
    // اگر صفحه روی HTTPS است و socket روی HTTP است، از polling استفاده کن
    const isHttpsPage = window.location.protocol === 'https:';
    const isHttpSocket = socketUrl.startsWith('http://');
    const preferPolling = isHttpsPage && isHttpSocket;
    
    this.socket = io(socketUrl, {
      transports: preferPolling ? ['polling'] : ['polling', 'websocket'], // اگر HTTPS به HTTP، فقط polling
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 10,
      reconnectionDelayMax: 5000,
      upgrade: !preferPolling, // اگر HTTPS به HTTP، upgrade نکن
      rememberUpgrade: !preferPolling,
      timeout: 20000,
      forceNew: false, // استفاده از connection موجود
      autoConnect: true,
      // برای HTTP socket روی HTTPS page
      ...(preferPolling && {
        withCredentials: false,
        extraHeaders: {}
      })
    });
    
    // Error handling
    this.socket.on('connect_error', (error) => {
      console.error('❌ Socket connection error:', error);
      console.log('Socket URL:', socketUrl);
      console.log('Page protocol:', window.location.protocol);
    });
    
    this.socket.on('connect', () => {
      console.log('✅ Socket connected successfully');
    });
    
    this.socket.on('disconnect', (reason) => {
      console.warn('⚠️ Socket disconnected:', reason);
    });
    
    this.socket.on('reconnect', (attemptNumber) => {
      console.log('✅ Socket reconnected after', attemptNumber, 'attempts');
    });
    
    this.socket.on('reconnect_error', (error) => {
      console.error('❌ Socket reconnection error:', error);
    });

    const en_date = new Date(this.state.tarikh);
    const year = en_date.getFullYear();

    var live = this;
    live.echoJoin();
    live.getVisitDuration();

    // ارسال درخواست برای دریافت پیام‌های چت
    this.socket.emit("fetchMessages", {
      roomToken: this.props.VisitToken,
      senderid: this.user.id,
      geterid: this.props.AudienceID
    });

    // دریافت پیام جدید از سرور
    this.socket.on(`newMessage:${this.props.VisitToken}`, (newMessage) => {
      this.socket.emit("fetchMessages", {
        roomToken: this.props.VisitToken,
        senderid: this.user.id,
        geterid: this.props.AudienceID
      });

      this.setState(prevState => {

        const updatedChats = prevState.chats.map(chat => {
          
          if (chat.audience_id !== this.props.user_id) {
            console.log("this ch", chat);
            return { ...chat, seen_audience: 1 };
          }

          return chat;
        });

        return {
          chats: [...updatedChats, newMessage],
          showReplyDiv: false,
        };
      }, () => {
        // اسکرول به پایین پس از اضافه شدن پیام جدید
        if (document.getElementById("chat_list_end")) {
          document.getElementById("chat_list_end").scrollIntoView({ behavior: "smooth" });
        }
      });

      if (this.props.VisitToken === newMessage.roomToken) {
        this.socket.emit('markAsSeen', { messageId: newMessage.id, roomToken: newMessage.roomToken });
      }
    });

    this.socket.on("chatHistory", (messages) => {
      this.setState({ chats: messages, loading: false }, () => {
        if (document.getElementById("chat_list_end")) {
          document.getElementById("chat_list_end").scrollIntoView({ behavior: "smooth" });
        }
      });
    });



    // مدیریت تغییر اندازه پنجره
    window.addEventListener("resize", live.onWindowResize, false);

    // مخفی کردن فوتر و بخش‌های دیگر
    var mainElement = document.getElementById("main_footer");
    if (mainElement) {
      mainElement.classList.add("hide_footer");
    }

    var footerElement = document.getElementById("main");
    if (footerElement) {
      footerElement.classList.add("hide_mood_main");
    }
  }

  socketfetcher() {

  }

  setUserForSocket() {
    const { AudienceID } = this.props;
    this.socket.emit('setUser', { id: this.user.id, AudienceID });
  }


  pad = (val) => {
    let valString = val + "";
    if (valString.length < 2) {
      return "0" + valString;
    } else {
      return valString;
    }
  };


  getVisitDuration = () => {

    var token = this.props.VisitToken;
    const LiveObject = this;

    const RequestService = HTTPServices.getMethod(
      "doctor-visit-duration",
      "token=" + token,
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        LiveObject.setState({
          totalSeconds: response,
        });
        let minutesLabel;
        let secondsLabel;
        function pad(val) {
          let valString = val + "";
          if (valString.length < 2) {
            return "0" + valString;
          } else {
            return valString;
          }
        }
        minutesLabel = pad(response % 60);
        secondsLabel = pad(parseInt(response / 60));
        LiveObject.setState({ secondsLabel, minutesLabel });
      }
    });
  };

  ChatCallChannel = this.props.echo().join(`chat.${this.props.VisitToken}`);



  echoJoin = () => {

    if (document.getElementById("chat_list_end"))

      this.ChatCallChannel.here((users) => {
        let audienceUser = users.find(
          (user) => user.id !== this.props.UserLogin.client_id
        );

        this.setState({
          audienceUser,
        });

        this.props.SeenChat();

        setTimeout(() => {
          if (audienceUser) {
            let el = document.getElementById("member_" + audienceUser.id);
            el.classList.add("online", "public_online");
          }
        }, 500);
      })
        .joining((user) => {
          // console.log(JSON.stringify(user), " Join the Channel");
          setTimeout(() => {
            let el = document.getElementById("member_" + user.id);
            if (el) {
              el.classList.add("online", "public_online");
            }
          }, 500);

          setTimeout(() => {
            var NewChat = [];
            let LiveObject = this;
            _.map(LiveObject.state.chats, (chat) => {
              if (
                chat.user_id === this.props.UserLogin.client_id &&
                user.id === chat.audience &&
                chat.seen === false
              ) {
                chat.seen = true;
              }
              NewChat.push(chat);
            });
            LiveObject.setState({
              chats: NewChat,
            });
          }, 1000);
        })
        .leaving((user) => {
          // console.log(user.id + " Leave the Channel");
          setTimeout(() => {
            let el = document.getElementById("member_" + user.id);
            if (el) {
              el.classList.remove("online");
            }
          }, 500);
        })
        .listen("MessageSent", (e) => {
          var LiveObject = this;

          if (e) {
            if (!Array.isArray(e.data)) {
              if (parseInt(e.data.user_id) !== parseInt(this.user.id)) {

                LiveObject.setState({
                  chats: [...LiveObject.state.chats, e.data],
                });


                if (document.getElementById("chat_list_end"))

                  console.log("end 7")

                if (e.data.id) {
                  LiveObject.SeenMessage(e.data.id);
                }
              }
            } else {
              e.data.map((dossier) => {
                LiveObject.setState({
                  chats: [...LiveObject.state.chats, dossier],
                });

                if (document.getElementById("chat_list_end"))

                  console.log("end 8")

                if (dossier.id) {
                  LiveObject.SeenMessage(dossier.id);
                }
              });
            }
          }

        })
        .listen("SeenMessage", (e) => {
          //new seen message
          var LiveObject = this;

          if (parseInt(e.message.user_id) === parseInt(this.user.id)) {
            // LiveObject.setState({
            //   chats: [...LiveObject.state.chats, e.data],
            // });

            if (document.getElementById("chat_list_end"))

              console.log("end 10")

            if (e.message.seen_audience === 1) {
              setTimeout(() => {
                var NewChat = [];
                _.map(LiveObject.state.chats, (chat) => {
                  if (e.message.id === chat.key) {
                    chat.seen = true;
                  }
                  NewChat.push(chat);
                });
                LiveObject.setState({
                  chats: NewChat,
                });
              }, 1000);
            }
          }
        })
        .listenForWhisper("typing", (e) => {
          this.setState({ isTyping: e.typing });
        });
  };

  onWindowResize = () => {
    // if (document.querySelector(".chat_room")) {
    //   var h = window.innerHeight;
    //   h = h - 188;
    //   var windosoze = window.innerWidth;
    //   if (windosoze < 993) {
    //     //document.querySelector('.client_body').style.height= h + 'px';
    //   }
    // }
  };

  scrollToEnd() {
    const chatListEnd = document.getElementById("chat_list_end");
    if (chatListEnd) {
      chatListEnd.scrollIntoView();
    }
  }



  addMessage(message) {
    const { AudienceID, VisitToken } = this.props;
    const { rep_to } = this.state;

    console.log("this is messages for us", message);

    if (message) {
      let params = {};
      if (message.file) {
        params = {
          userid: this.user.id,
          type: message.type || "voice_message",
          file: message.file || null,
          audience_id: AudienceID,
          message: message.message || "null",
          room_token: VisitToken,
          reply_to: rep_to || null,
        };
      } else {
        params = {
          userid: this.user.id,
          type: message.type || "text",
          file: message.file || null,
          audience_id: AudienceID,
          message: message || "",
          room_token: VisitToken,
          reply_to: rep_to || null,
        };
      }

      console.log("reply", rep_to);
      this.setState({ text: "" });

      // ارسال پیام از طریق سوکت
      this.socket.emit('sendMessage', params);


      // بازنشانی مقدار rep_to به null پس از ارسال پیام
      this.setState({ rep_to: null });

      this.socket.off(`newMessage:${VisitToken}`);

      this.socket.on(`newMessage:${VisitToken}`, (newMessage) => {
        



        this.setState(prevState => {
          console.log("user id" , newMessage.user_id)
          console.log("user id 1" , this.props.AudienceID)
          const mynewMessage = prevState.chats.map((val) => {
            
            if(newMessage.user_id == this.props.AudienceID){
              if (val.user_id == this.user.id) {
                
                return { ...val, seen_audience: 1 }
              }
            }
           
            return val;
          })
          
          return {
            chats: [...mynewMessage, newMessage],
            showReplyDiv: false,
          }
        });


        if (document.getElementById("chat_list_end")) {
          document.getElementById("chat_list_end").scrollIntoView();

          console.log("end 12")
        }
      });

      if (document.getElementById("chat_list_end")) {

        console.log("end 13")
      }
    }
  }
  SeenMessage(key) {

  }

  timer = null;

  handleTextChange(e) {
    clearTimeout(this.timer);

    this.setState({ text: e.target.value });

    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
    this.setState((prevState) => {
      if (!prevState.doTyping) {
        return { doTyping: true };
      }
    });
    if (!this.state.doTyping) {
      this.ChatCallChannel.whisper("typing", {
        typing: true,
        name: this.props.UserLogin.fullname,
      });
    }

    if (e.keyCode === 13) {
      clearTimeout(this.timer);
      this.ChatCallChannel.whisper("typing", {
        typing: false,
        name: this.props.UserLogin.fullname,
      });
      this.setState({ dfoTyping: false });

      this.addMessage(this.state.text);
    } else {
      this.setState({ text: e.target.value });
    }
  }

  triggerChange = () => {
    this.ChatCallChannel
      // .here((user) => {
      //   console.log("chat call component triggerChange", user);
      // })
      .whisper("typing", {
        typing: false,
        name: this.props.UserLogin.fullname,
      });
    this.setState({ doTyping: false });
  };

  send(e) {

    this.addMessage(this.state.text);
    if (this.state.showReplyDiv) {
      this.setState({ showReplyDiv: false });
    }
  }

  addMessageToList = (message) => {
    console.log("add me", message)

    if (message.file) {
      this.addMessage(message)
    } else {
      this.setState({
        chats: [...this.state.chats, message],
        attachType: "",
      });

      setTimeout(function () {
        if (document.getElementById("chat_list_end"))
          document.getElementById("chat_list_end").scrollIntoView();

        console.log("end 1")
      }, 100);
    }






  };

  addmultifileMessageToList = (message) => {
    console.log("addmultifileMessageToList")
    if (Array.isArray(message)) {
      message.forEach((element) => {

        this.addMessage(element)
        this.setState({
          attachType: "",
          showMedicalDocuments: false,
          showMedicalInstructions: false,
        });
      });
    } else {
      this.setState({
        chats: [...this.state.chats, message],
        attachType: "",
        showMedicalDocuments: false,
        showMedicalInstructions: false,
      });
    }
    setTimeout(function () {
      if (document.getElementById("chat_list_end"))

        console.log("end 2")
    }, 100);
  };

  confirmDeleteDialoge = (selectedChat) => {
    this.setState({
      confirmDeleteDialoge: true,
      deleted_id: selectedChat.id,
      selectedChat,
    });
  };

  ConfirmDeleteMessage = () => {
    const { VisitToken } = this.props;
    const { deleted_id } = this.state;

    console.log("hi", VisitToken)

    // Emit socket event to delete the message
    this.socket.emit('deleteMessage', {
      messageId: deleted_id,
      roomToken: VisitToken
    });

    this.socket.on(`updatedChat:${VisitToken}`, (newMessage) => {

      this.setState(prevState => ({
        chats: [...newMessage],
        confirmDeleteDialoge: false,
      }));

    });
  };

  replyAction = (chat) => {

    this.setState({
      rep_to: chat.id,
      showReplyDiv: true,
    });

    if (document.getElementById("chat_list_end")) {

      console.log("end 4")
    }
  };

  deleteAction = (chat) => {


    this.setState({
      deleted_id: chat.id,
    });

    if (document.getElementById("chat_list_end")) {

      console.log("end 3")
    }
  }

  cancelRepleing = () => {
    this.setState({
      rep_to: null,

      showReplyDiv: false,
    });
  }

  VideoRecordHandler = () => {
    if (!window.RTCPeerConnection === false) {
      this.setState({ showVideoRecordMenu: true });
    } else {
      this.setState({ showVideoRecordMenu: true });
      // this.setState({ showRtcUnsupported: true });
    }
  };

  VoiceRecordHandler = () => {
    if (!window.RTCPeerConnection === false) {
      this.setState({ showVoiceRecordMenu: true });
    } else {
      this.setState({ showVideoRecordMenu: true });
      // this.setState({ showRtcUnsupported: true });
    }
  };

  medicalDocumentsHandler = () => {
    this.setState({ showMedicalDocuments: true });
  };

  medicalInstructionsHandler = () => {
    this.setState({ showMedicalInstructions: true });
  };

  handleOpenCompressedImageDialog = () => {
    this.setState({ showCompressedUploadMenu: true });
  };

  AddFile = () => {
    this.setState({ showMedicalDocuments: false, showFileUploadMenu: false });
  };

  wordSuggestions = (e) => {
    e.preventDefault();
    let usedWord = e.currentTarget.value;
    let newWords = this.state.words.filter((word) => word != usedWord);
    this.setState((state) => {
      return { words: newWords };
    });
    this.addMessage(usedWord);

    setTimeout(function () {
      if (document.getElementById("chat_list_end"))

        console.log("end 6")
    }, 100);
  };

  setAttachTypeprescription = () => {
    this.setState({
      attachType: "prescription",
    });
  };

  render() {
    const { AudienceID, StatusOpen, VisitToken } = this.props;

    if (this.state.loading) {
      return (
        <div className="chat_room">
          <div className="preloader_set">
            <div className="cssload-speeding-wheel" />
          </div>
        </div>
      );
    }

    return (
      <div
        // className='main_chat'
        className={StatusOpen ? "chat_room" : "chat_room end_room"}
        id={"chat_room_" + AudienceID}
      // style={{ border: '2px solid blue' }}
      >

        {this.state.isTyping ? (
          <div style={{ textAlign: "center", opacity: 0.5, color: "green" }}>
            مخاطب در حال تایپ
          </div>
        ) : null}
        {/* <div className='chat_header'>
          sdjfhsdkfj
        </div> */}
        <ChatList
          UserId={this.user.id}
          chats={this.state.chats}

          reply={(chat) => { this.replyAction(chat); }}
          deleteMessage={(selectChat) => { this.confirmDeleteDialoge(selectChat) }}
        />

        {this.state.showFileUploadMenu ? (
          <FileUpload
            roomToken={this.props.VisitToken}
            addMessageToList={this.addMessageToList}
            AudienceID={AudienceID}
            open={this.state.showFileUploadMenu}
            userId={this.user.id}
            handleClose={() =>
              this.setState({ showFileUploadMenu: false, attachType: "" })
            }
            attachType={this.state.attachType}
          />
        ) : null}

        {this.state.showCompressedUploadMenu ? (
          <CompressedImageUpload
            roomToken={this.props.VisitToken}
            addMessageToList={this.addMessageToList}
            AudienceID={AudienceID}
            open={this.state.showCompressedUploadMenu}
            userId={this.user.id}
            handleClose={() =>
              this.setState({ showCompressedUploadMenu: false })
            }
          />
        ) : null}

        {this.state.showVoiceRecordMenu ? (
          <VoiceRecorder
            roomToken={this.props.VisitToken}
            addMessageToList={this.addMessageToList}
            AudienceID={AudienceID}
            userId={this.user.id}
            open={this.state.showFileUploadMenu}
            handleClose={() => this.setState({ showVoiceRecordMenu: false })}
            cancel={() => {
              this.setState({ showVoiceRecordMenu: false, attachType: "" });
            }}
            attachType={this.state.attachType}
          />
        ) : null}

        {this.state.showVideoRecordMenu ? (
          <VideoRecorderDialoge
            roomToken={this.props.VisitToken}
            addMessageToList={this.addMessageToList}
            closeDialoge={() => {
              this.setState({ showVideoRecordMenu: false, attachType: "" });
            }}
            AudienceID={this.props.AudienceID}
            attachType={this.state.attachType}
          />
        ) : null}

        {StatusOpen ? (
          <div className="wordSuggestions-wrapper chat_input_tools">
            <ChatBox
              text={this.state.text}
              username={this.state.username}
              handleTextChange={this.handleTextChange}
              handleSend={this.send}
              handleOpenFileUploadDialog={() => this.setState({ showMedicalDocuments: true })}
              handleOpenFileUploadDialogDR={() => this.setState({ showMedicalInstructions: true })}
              handleOpenVoiceRecorderDialog={this.VoiceRecordHandler}
              handleOpenVideoeRecorderDialog={this.VideoRecordHandler}
              medicalDocuments={this.medicalDocumentsHandler}
              medicalInstructions={this.medicalInstructionsHandler}
              showReplyDiv={this.state.showReplyDiv}
              cancelRepleing={this.cancelRepleing}
              // selectedToReply={this.state.selectedToReply.message}
              selectedToReply={this.state.selectedToReply}

              handleOpenCompressedImageDialog={this.handleOpenCompressedImageDialog}
              VisitToken={VisitToken}
              AudienceID={AudienceID}
              addMessageToList={this.addMessageToList}
              attachType={this.state.attachType}
              setAttachTypeprescription={this.setAttachTypeprescription}
              setAttachTypeDefault={() => this.setState({ attachType: "" })}
            />
          </div>
        ) : (
          this.props.Dr_info ?
            <div className='new-reserve-same-dr'>
              <a className='button secondary' href={DataServices.webConfig("info_site") + this.props.Dr_info.doctor_username}>
                <h6>رزرو وقت جدید از همین دکتر</h6>
              </a>
            </div> : null
        )}
        {this.state.showMedicalDocuments && (
          <div>
            <Dialog
              open={true}
              onClose={() => {
                this.setState({ showMedicalDocuments: false });
              }}
              aria-labelledby="form-dialog-title"
            >
              <Box sx={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                <DialogTitle id="scroll-dialog-title">
                  ثبت مستندات جدید
                </DialogTitle>
                <IconButton onClick={() => {
                  this.setState({ showMedicalDocuments: false });
                }}>

                  <HighlightOffIcon sx={{ width: "3rem !important", height: "3rem !important", color: "#de0036" }} />
                </IconButton>
              </Box>
              <DialogContent>
                <DialogContentText className="dialog_text" sx={{
                  fontSize: "1.25rem !important",
                  fontWeight: "800 !important",
                  width: "90% !important",
                  marginX: "auto"
                }}>
                  برای ثبت مستند جدید لطفا اطلاعات بخش زیر را وارد کنید.
                </DialogContentText>

                <AddAttachFile
                  AddFile={(messages) => {
                    this.addmultifileMessageToList(messages);
                  }}
                  VisitToken={this.props.VisitToken}
                  AudienceID={AudienceID}
                />
              </DialogContent>

              <DialogActions>
                {/* <Button
                  onClick={() => {
                    this.setState({ showMedicalDocuments: false });
                  }}
                  color="primary"
                  className="button_dialog"
                >
                  بستن پنجره
                </Button> */}
                {/* <button
                  onClick={() => {
                    this.setState({ showMedicalDocuments: false });
                  }}
                  className="button"
                >
                  بستن پنجره
                </button> */}
              </DialogActions>
            </Dialog>
          </div>
        )}
        {this.state.showMedicalInstructions && (
          <div>
            <Dialog
              open={true}
              onClose={() => {
                this.setState({ showMedicalInstructions: false });
              }}
              aria-labelledby="form-dialog-title"
            >
              <div className="dialog-header">
                <div className="dialog-header-title">
                  <div className="dialog-header-icon">
                    <DriveFolderUploadRoundedIcon sx={{ fontSize: "30px", margin: "0px" }} />
                  </div>
                  اپلود فایل
                </div>
                <IconButton
                  onClick={() => {
                    this.setState({
                      showMedicalInstructions: false,
                    });
                  }}
                  color="error"
                  sx={{
                    aspectRatio: 1,
                    width: "25px",
                    height: "25px",
                    backgroundColor: "rgb(250, 156, 156)",
                  }}
                  aria-label="delete"
                >
                  <ClearIcon />
                </IconButton>
              </div>
              {/* <DialogTitle id="scroll-dialog-title">
                ارسال دستور پزشکی جدید
              </DialogTitle> */}
              <DialogContent>
                {/* <DialogContentText className="dialog_text">
                  برای ثبت مستند جدید لطفا اطلاعات بخش زیر را وارد کنید.
                </DialogContentText> */}
                <div className="center-content">
                  <AddPrescription
                    AddFile={(messages) => {
                      this.addmultifileMessageToList(messages);
                    }}
                    VisitToken={this.props.VisitToken}
                    AudienceID={AudienceID}
                  />
                </div>


              </DialogContent>

              {/* <DialogActions>
                <button
                  onClick={() => {
                    this.setState({
                      showMedicalInstructions: false,
                    });
                  }}
                  className="button"
                >
                  بستن پنجره
                </button>
              </DialogActions> */}
            </Dialog>
          </div>
        )}
        <Dialog
          open={this.state.confirmDeleteDialoge}
          onClose={() => this.setState({ confirmDeleteDialoge: false })}
        >
          <DialogTitle className="dialog-text">
            <p>آیااز حذف پیام مطمئن هستید؟</p>
          </DialogTitle>
          <DialogActions>
            {/* <Button
              autoFocus
              onClick={() => this.setState({ confirmDeleteDialoge: false })}
              color="primary"
              className="button_dialog"
            >
              انصراف
            </Button> */}
            <button
              autoFocus
              onClick={() => this.setState({ confirmDeleteDialoge: false })}
              className="button"
            >
              انصراف
            </button>
            {/* <Button
              onClick={this.ConfirmDeleteMessage}
              color="primary"
              autoFocus
              className="button_dialog"
            >
              تایید
            </Button> */}
            <button
              onClick={this.ConfirmDeleteMessage}
              autoFocus
              className="button"
            >
              تایید
            </button>
          </DialogActions>
        </Dialog>
        {/* {this.state.showRtcUnsupported ? (
          <Dialog
            open={this.state.showRtcUnsupported}
            onClose={() => this.setState({ showRtcUnsupported: false })}
          >
            <DialogTitle className="dialog-text">
              <p>
                کاربر گرامی مرورگر شما از این قابلیت پشتیبانی نمی کند لطفا
                مرورگر خود را بروزرسانی نمایید
              </p>
            </DialogTitle>
            <DialogActions>
              <Button
                onClick={() => {
                  this.setState({ showRtcUnsupported: false });
                }}
                color="primary"
                autoFocus
                className="button_dialog"
              >
                متوجه شدم
              </Button>
            </DialogActions>
          </Dialog>
        ) : null} */}
      </div>
    );
  }
}

export default ChatCall;

const styles = {
  suggestedWords: {},
};

let systemMessages = [
  {
    message: (
      <>
        <span>کاربر گرامی سلام و آرزوی سلامتی،</span>
        <br />
        <span>شما در اتاق مشاوره پزشک خود هستید. خواهشمند است :</span>
        <br />
        <span>
          - دلیل مشاوره با پزشک را یا تایپ نموده و یا بصورت پیام صوتی و ویدیویی
          ( از قسمت ارسال مستندات ) برای پزشک ارسال نمایید.
        </span>
        <br />
        <span>
          - از آخرین آزمایش و مدارک پزشکی خود عکس بگیرید و با کلیک بر روی{" "}
          <b>ارسال مدارک </b>
          ارسال نمایید.
        </span>
        <br />
        <span>
          - اسامی داروهایی که مصرف می کنید در قسمت چت وارد کنید و یا عکس آن را
          با کلیک بر روی <b>ارسال مدارک</b> ارسال نمایید.
        </span>
        {/* 
        <br />
        <span>
          مدت انتظار شما از زمان موعد ویزیت تا حضور پزشک نهایتاً ۳ ساعت میباشد.
        </span> */}
      </>
    ),
    type: "systemMessages",
  },
];
